export default __webpack_public_path__ + "static/media/icon-coffee-bean.a39b0780.svg";